import Pagination from './Pagination.vue'

export default Pagination



//////////////////
// WEBPACK FOOTER
// ./~/vue-bulma-pagination/src/index.js
// module id = 23
// module chunks = 0